(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/toplists/receiver-toplists-most-popular-points.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/toplists/receiver-toplists-most-popular-points.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.ReceiverToplistsMostPopularPoints = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.receiver_toplists_most_popular_points(data);
    },

    regions: {
      topListsMostPopularPoints: '.js-receiver-toplists-most-popular-points'
    },

    events: {
      'click .js-fetch-more': 'fetchMore'
    },
    collectionEvents: {
      change: 'render'
    },
    tagName: 'div',
    className: 'most-popular-points-wrapper',

    onRender: function() {
      this.getRegion('topListsMostPopularPoints').show(new svs.grassroots.views.ReceiverToplistsMostPopularPointsList({
        collection: this.options.collection
      }));
    },

    fetchMore: function() {
      var offset = this.model.get('offsetPoints');
      this.model.set('offsetPoints', offset + 10);
      svs.ui.loader.show();
      this.options.collection.fetchMoreItems(1, offset);
    }
  });
})(Backbone, _, svs);


 })(window);